import React from 'react';
import { StyleSheet, View } from 'react-native';
import TextField from './TextField';

const styles = StyleSheet.create({
  container: {
    width: '100%',
    flexDirection: 'column', // Change to 'column' to display components vertically
    alignItems: 'center', // Optional: Align components in the center vertically
  },
});

interface Props {
  data: string[] | number[];
}

const ListTextField: React.FC<Props> = ({ data }) => {
  return (
    <View style={styles.container}>
      {data.map((item, index) => (
        <TextField key={index} data={item.name} />
      ))}
    </View>
  );
};

export default ListTextField;
